import { create } from 'zustand';

export const createPanditoLocationSlice = create((set, get) => ({

  panditoLocationNow: { lat: null, lng: null },

  setPanditoLocationNow: (newLocation) => set({ panditoLocationNow: newLocation })

}));
